import {arrayToOptions} from '../reports/array-to-options'
import {fabricationsList, singleSizesList, sizesList, repList, seasonList} from '../cads/unminify'
import {compare} from '../generate-style-number/options'

const status = [
  "All",
  "Best Seller",
  "Average Seller",
  "Poor Seller",
  "Reviewed",
  "On Hand",
  "ATS",

  "ATS or Future ATS",
  "Future Stock",
  "Future ATS",
  "Future ATS Confirmed",
  "Pending PI",
  "Loading Date",
  "Shipped",
  "Ready To Ship",
  "PO",
  "Pending PO",
  "Hold",
  "Worksheet",
  "No Image",
  "Age",
  "Season",
  "Container #",
  "Group ID",
  // "Non Latin Characters",
  // "Duplicate VPO"
  "ATS Rep",
  "Sizes",
  "Cost",
  "Fabrication",
  "Do Not Sell",
  "Warehouse",
  "Oversold",
  "POE",
  "Ticketed PO",
  "Ticketed VPO",
  "Sub2"
]
const ellipsis = ['View', 'Edit']
const sort = ['Sort by: Name', 'Sort by: Created', 'Sort by: Search textbox', 'Sort by: Most shipped']

const statusOptions = arrayToOptions(status)
const ellipsisOptions = arrayToOptions(ellipsis)
const sortOptions = arrayToOptions(sort)

const fabricationOptions = fabricationsList.filter((value, index, self) => {
  return self.indexOf(value) === index
}).map((x) => {return { key: x, text: x, value: x}}).sort(compare)

const sizesOptions = singleSizesList.concat(sizesList).map((x) => {return { key: x, text: x, value: x}})

const repOptions = ['All'].concat(repList.filter(x => x.includes('@'))).map(x => x.replace('_sales','').replace('@ihlgroup.com','')).filter((value, index, self) => {
  return self.indexOf(value) === index
}).map((x) => {return { key: x, text: x, value: x}})

const seasonOptions = seasonList.map((x) => {return { key: x, text: x, value: x}}).sort(compare)

// admins can filter for cads with no season assigned (same as the old cads page)
const seasonOptionsAdmin = seasonOptions.concat([{ key: 'Missing', text: 'Missing', value: 'Missing' }])

// group options shown above the individual divisions - selecting one matches every division in the group
const divisionGroups = {
  'ALL BOYS': ['BOYS', 'BIG BOY', 'LITTLE BOYS', 'JUNIOR BOYS', 'INFANT BOY', 'TODDLER BOY', 'NEWBORN BOY'],
  'ALL GIRLS': ['GIRLS', 'JUNIOR GIRLS', 'INFANT GIRL', 'TODDLER GIRL', 'NEWBORN GIRL']
}

const divisionGroupOptions = Object.keys(divisionGroups).map((x) => {return { key: x, text: x, value: x}})

const expandDivisions = (division) => {
  return division.map(x => divisionGroups[x] != null ? divisionGroups[x] : [x.split(' = ')[1]]).flat()
}

export {statusOptions, ellipsisOptions, fabricationOptions, sizesOptions, sortOptions, repOptions, seasonOptions, seasonOptionsAdmin, divisionGroupOptions, expandDivisions}
